/**
 * Bots' work in lists (the Bots page, a project's chat history): grouped by when it
 * happened, one row per conversation.
 */

const DAY = 86400000;

/** today, yesterday, week (the 7 days before) or older, in the person's own day. */
export const bucketOf = (iso, now = new Date()) => {
  const today = new Date(now); today.setHours(0, 0, 0, 0);
  const t = new Date(iso).getTime();
  if (t >= today.getTime()) return 'today';
  if (t >= today.getTime() - DAY) return 'yesterday';
  if (t >= today.getTime() - 6 * DAY) return 'week';
  return 'older';
};

export const BUCKETS = ['today', 'yesterday', 'week', 'older'];
export const BUCKET_LABELS = {
  today: 'bots.chat.group_today', yesterday: 'bots.chat.group_yesterday',
  week: 'bots.chat.group_week', older: 'bots.chat.group_older',
};

/** The time today, the date before. */
export const when = (iso, locale, now = new Date()) => {
  if (!iso) return '';
  const d = new Date(iso);
  return bucketOf(iso, now) === 'today'
    ? d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
};

/**
 * One row per conversation: a chat's or a task's latest run (they come newest first),
 * with how many runs it had. A chat of ten messages used to fill the list ten times.
 */
export const latestPerConversation = (runs = []) => {
  const rows = new Map();
  (runs || []).forEach((r) => {
    const key = r.chat_id ? `chat:${r.chat_id}` : r.task_id ? `task:${r.task_id}` : `run:${r.id}`;
    if (rows.has(key)) rows.get(key).runs += 1;
    else rows.set(key, { ...r, runs: 1 });
  });
  return [...rows.values()];
};
